import { render } from "./CardsList.vue?vue&type=template&id=f9c4512e"
import script from "./CardsList.vue?vue&type=script&lang=js"
export * from "./CardsList.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "f9c4512e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9c4512e', script)) {
    api.reload('f9c4512e', script)
  }
  
  module.hot.accept("./CardsList.vue?vue&type=template&id=f9c4512e", () => {
    api.rerender('f9c4512e', render)
  })

}

script.__file = "src/views/settings/modules/payments/CardsList.vue"

export default script